module.exports = "App.Models.Extension = Backbone.Model.extend({});"